jQuery(function ($) {
  let searchInstantResultTimeout;

  var SearchInstantResultsHandler = function (prefix, modal) {
    console.log(prefix);
    console.log(modal);
    let handler = this;

    if (modal) {
      this.setModalPosition();
      $('[data-instant-search="' + prefix + 'input"]').on(
        'keydown',
        {
          handler: this,
          prefix: prefix,
          modal: modal,
        },
        this.displayModal
      );
      $('[data-instant-search="' + prefix + 'input"]').on(
        'click',
        {
          handler: this,
          prefix: prefix,
          modal: modal,
        },
        this.displayModalClick
      );
    }

    $('[data-instant-search="' + prefix + 'input"]').on(
      'keyup',
      {
        handler: this,
        prefix: prefix,
        modal: modal,
      },
      this.checkCanSearch
    );
    $('[data-instant-search="' + prefix + 'clear"]').on(
      'click',
      {
        handler: this,
        prefix: prefix,
        modal: modal,
      },
      this.clearSearchClick
    );
    $('body').on('instant_search_content_loaded', function () {
      $('[data-instant-search="' + prefix + 'did-you-mean"]').on(
        'click',
        {
          handler: handler,
          prefix: prefix,
          modal: modal,
        },
        handler.didYouMeanClick
      );
    });
  };

  SearchInstantResultsHandler.prototype.fetchContent = function (
    prefix,
    modal
  ) {
    let handler = this;
    $.ajax({
      url: search_instant_results_ajax_var.url,
      data: {
        action: 'elasticpress-instant-results',
        search: $('[data-instant-search="' + prefix + 'input"]').val(),
      },
      type: 'GET',
      beforeSend: function (xhr) {
        $('body').trigger('instant_search_content_requested');
      },
      success: function (data) {
        let search_content = data.fragments['search-' + prefix + 'content'];
        $('[data-instant-search="' + prefix + 'content"]').html(search_content);
        $('body').trigger('instant_search_content_loaded');
      },
      error: function (XMLHttpRequest, status, errorMessage) {},
    });
  };

  SearchInstantResultsHandler.prototype.displayModal = function (event) {
    let handler = event.data.handler;
    let prefix = event.data.prefix;
    let modal = event.data.modal;
    $('[data-instant-search="container"]').addClass('active');
    $('[data-instant-search="modal"]').removeClass('is-closed');
    $('[data-instant-search="overlay"]').removeClass('is-closed');
  };

  SearchInstantResultsHandler.prototype.displayModalClick = function (event) {
    let handler = event.data.handler;
    let prefix = event.data.prefix;
    let modal = event.data.modal;
    if ($(event.target).val()) {
      handler.displayModal();
    }
  };

  SearchInstantResultsHandler.prototype.closeModal = function () {
    $('[data-instant-search="container"]').removeClass('active');
    $('[data-instant-search="modal"]').addClass('is-closed');
    $('[data-instant-search="overlay"]').addClass('is-closed');
  };

  SearchInstantResultsHandler.prototype.clearSearch = function (prefix, modal) {
    $('[data-instant-search="' + prefix + 'input"]').val('');
    if (modal) {
      this.closeModal();
    }
    this.clearContent(prefix, modal);
  };

  SearchInstantResultsHandler.prototype.clearContent = function (
    prefix,
    modal
  ) {
    $('[data-instant-search="' + prefix + 'content"]').html(
      '<div class="absolute left-0 right-0 top-0 bottom-0 h-full flex justify-center items-center"></div>'
    );
    $('[data-instant-search="' + prefix + 'content"]')
      .parent()
      .parent()
      .parent()
      .addClass('search-results-loaded');
    $('[data-instant-search="' + prefix + 'content"]')
      .parent()
      .parent()
      .parent()
      .addClass('search-results-loading');
  };

  SearchInstantResultsHandler.prototype.loading = function (prefix, modal) {
    $('[data-instant-search="' + prefix + 'content"]').html(
      '<div class="absolute left-0 right-0 top-0 bottom-0 h-full flex justify-center items-center"><img src="/app/themes/penkethstore/dist/images/spinner-greyscale.gif" class="w-12 h-12"/></div>'
    );
    $('[data-instant-search="' + prefix + 'content"]')
      .parent()
      .parent()
      .parent()
      .addClass('search-results-loading');
  };

  SearchInstantResultsHandler.prototype.clearSearchClick = function (event) {
    let handler = event.data.handler;
    let prefix = event.data.prefix;
    let modal = event.data.modal;
    handler.clearSearch(prefix, modal);
  };

  SearchInstantResultsHandler.prototype.didYouMeanClick = function (event) {
    let handler = event.data.handler;
    let prefix = event.data.prefix;
    let modal = event.data.modal;
    event.preventDefault();
    handler.loading(prefix, modal);
    let searchAlt = $(event.target);
    $('[data-instant-search="' + prefix + 'input"]').val(
      searchAlt.attr('data-instant-search-text')
    );
    handler.fetchContent(prefix, modal);
  };

  SearchInstantResultsHandler.prototype.checkCanSearch = function (event) {
    let handler = event.data.handler;
    let prefix = event.data.prefix;
    let modal = event.data.modal;
    handler.loading(prefix, modal);
    let input = $(event.target);
    clearTimeout(searchInstantResultTimeout);
    searchInstantResultTimeout = setTimeout(function () {
      handler.fetchContent(prefix, modal);
    }, 1200);
    input.on('keydown', function () {
      clearTimeout(searchInstantResultTimeout);
    });
  };

  SearchInstantResultsHandler.prototype.setModalPosition = function () {
    var positionLeft = $('.c-search__input-container').position().left;
    var positionTop = $('.c-search__input-container').position().top;
    const mqLG = window.matchMedia('(min-width: 992px)');
    const mqXL = window.matchMedia('(min-width: 1280px)');
    if (mqLG.matches) {
      var top = 80;
    } else if (mqXL.matches) {
      var top = 60;
    }
    var positionTopFinal = positionTop + top;
    $('.c-modal__search').css({
      left: positionLeft,
      right: positionLeft,
      //top: positionTopFinal,
    });
  };

  let SIRHandler = new SearchInstantResultsHandler('', true);

  $('body').on('pre_basket_modal_loaded', function () {
    console.log('setting search for pre basket');
    let SIRHandlerPrebasket = new SearchInstantResultsHandler(
      'prebasket-',
      false
    );
    $('body').on('instant_search_content_loaded', function () {
      $('[data-instant-search="prebasket-content"]')
        .parent()
        .parent()
        .parent()
        .addClass('search-results-loaded');
      $('[data-instant-search="prebasket-content"]')
        .parent()
        .parent()
        .parent()
        .removeClass('search-results-loading');
    });
  });
});
